"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataAPIConfig = void 0;
var Endpoint_1 = require("./Endpoint");
var json2typescript_1 = require("json2typescript");
var DataAPIConfig = (function () {
    function DataAPIConfig(partial) {
        this.versions = [];
        this.runAsSystem = false;
        this.runAsUserId = '';
        this.runAsUserIdScriptSource = '';
        this.disabled = false;
        this.endpointValidationMethod = Endpoint_1.EndpointValidationMethod.NoValidation;
        this.secretName = '';
        this.respondResult = false;
        this.fetchCustomUserData = false;
        this.createUserOnAuth = false;
        this.returnType = undefined;
        this.logFunctionArguments = false;
        this.canEvaluate = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('versions', [String], true),
        __metadata("design:type", Array)
    ], DataAPIConfig.prototype, "versions", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_system', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "runAsSystem", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id', String, true),
        __metadata("design:type", String)
    ], DataAPIConfig.prototype, "runAsUserId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('run_as_user_id_script_source', String, true),
        __metadata("design:type", String)
    ], DataAPIConfig.prototype, "runAsUserIdScriptSource", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "disabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('validation_method', String, true),
        __metadata("design:type", String)
    ], DataAPIConfig.prototype, "endpointValidationMethod", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('secret_name', String, true),
        __metadata("design:type", String)
    ], DataAPIConfig.prototype, "secretName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('respond_result', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "respondResult", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('fetch_custom_user_data', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "fetchCustomUserData", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('create_user_on_auth', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "createUserOnAuth", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('return_type', String, true),
        __metadata("design:type", String)
    ], DataAPIConfig.prototype, "returnType", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('log_function_arguments', Boolean, true),
        __metadata("design:type", Boolean)
    ], DataAPIConfig.prototype, "logFunctionArguments", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('can_evaluate', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], DataAPIConfig.prototype, "canEvaluate", void 0);
    DataAPIConfig = __decorate([
        (0, json2typescript_1.JsonObject)('DataAPIConfig'),
        __metadata("design:paramtypes", [Object])
    ], DataAPIConfig);
    return DataAPIConfig;
}());
exports.DataAPIConfig = DataAPIConfig;
//# sourceMappingURL=DataAPI.js.map